module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('search-select', {
    staticClass: "forum-search-select",
    attrs: {
      "options": _vm.options,
      "value": _vm.value,
      "multiple": _vm.multiple,
      "placeholder": _vm.placeholder,
      "blurOnSelect": _vm.blurOnSelect
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-037e41b9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/search-select.vue
// module id = 1963
// module chunks = 2